// TypeScript interfaces for Associated Objects (Emails & Meetings)

export interface EmailMetadata {
    subject: string;
    sender: string;
    recipients: string[];
    timestamp: string;
    content: string;
    attachments?: any[];
    labels?: string[];
}

export interface MeetingMetadata {
    title: string;
    organizer: string;
    attendees: string[];
    start_time: string;
    end_time: string;
    location?: string;
    description?: string;
    meeting_platform?: string;
    meeting_url?: string;
    recording_available?: boolean;
}

export interface AssociatedObject {
    id: string;
    external_id: string;
    object_id?: string | null;
    thread_id?: string | null;
    company_domain?: string;
    meta_data: EmailMetadata | MeetingMetadata;
    key_fields_text?: string;
    embedding_status?: string;
    created_at: string;
    updated_at: string;
    object_type: 'emails' | 'meetings';
    singular_noun: string;
    plural_noun: string;
    relation_type: string;
    weight?: number;
    association_created_at: string;
}

export interface AssociatedObjectsResponse {
    account_external_id?: string;
    contact_external_id?: string;
    workspace_id: string;
    objects: AssociatedObject[];
    total_count: number;
    limit: number;
    offset: number;
    object_types_filter?: string[];
}

export interface EmailsResponse {
    account_external_id?: string;
    contact_external_id?: string;
    workspace_id: string;
    emails: AssociatedObject[];
    total_count: number;
    limit: number;
    offset: number;
}

export interface MeetingsResponse {
    account_external_id?: string;
    contact_external_id?: string;
    workspace_id: string;
    meetings: AssociatedObject[];
    total_count: number;
    limit: number;
    offset: number;
}

// Type guards
export function isEmailMetadata(meta: EmailMetadata | MeetingMetadata): meta is EmailMetadata {
    return 'subject' in meta && 'sender' in meta;
}

export function isMeetingMetadata(meta: EmailMetadata | MeetingMetadata): meta is MeetingMetadata {
    return 'title' in meta && 'organizer' in meta;
}
